import { render, staticRenderFns } from "./default.plane.vue?vue&type=template&id=281cfe7f&"
import script from "./default.plane.vue?vue&type=script&lang=ts&"
export * from "./default.plane.vue?vue&type=script&lang=ts&"
import style0 from "./default.plane.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
